// Checked
import axios from '../axios-admin';
import { handleError } from '../js/helpers';
import env from '../js/env';
import history from './../history';
import {
    SET_LOADING,
    SET_ERROR,
    RETRIEVE_FONTS_SUCCESS,
    RETRIEVE_FONT_SUCCESS,
    CREATE_FONT_SUCCESS,
    UPDATE_FONT_SUCCESS,
    DELETE_FONT_SUCCESS
} from './types';

const ROOT_URL = '/api';

export function retrieveFonts(page, search) {
    const currentPage = page || 1;
    const searchWord = search || null;
    let url = '';
    if (searchWord === null) {
        url = `${ROOT_URL}/all-font?limit=${env.GENERAL.paginator_limit}&lang=${env.GENERAL.lang}&page=${currentPage}`;
    } else {
        url = `${ROOT_URL}/all-font?limit=${env.GENERAL.paginator_limit}&lang=${env.GENERAL.lang}&page=${currentPage}&search=${searchWord}`;
    }
    return function (dispatch) {
        dispatch({ type: SET_LOADING });
        axios({
            method: 'get',
            url,
            headers: {
                'Content-Type': 'application/json',
                Accept: env.GENERAL.accept,
                Authorization: localStorage.getItem('token')
            }
        }).then((response) => {
            const paginatorResponse = response.data.data;
            dispatch(retrieveSuccess(paginatorResponse, RETRIEVE_FONTS_SUCCESS));
        }).catch((error) => {
            handleError(error);
            if (error !== undefined) {
                if (error.response !== undefined) {
                    dispatch(retrieveFail(error.response.data.message));
                }
            }
        });
    };
}

export function retrieveFont(id, font = null) {
    return function (dispatch) {
        dispatch({ type: SET_LOADING });
        if (!font) {
            axios({
                method: 'get',
                url: `${ROOT_URL}/font/${id}?lang=${env.GENERAL.lang}`,
                headers: {
                    'Content-Type': 'application/json',
                    Accept: env.GENERAL.accept,
                    Authorization: localStorage.getItem('token')
                }
            }).then((response) => {
                const fontResponse = response.data.data;
                dispatch(retrieveSuccess(fontResponse, RETRIEVE_FONT_SUCCESS));
            }).catch((error) => {
                handleError(error);
                if (error !== undefined) {
                    if (error.response !== undefined) {
                        dispatch(retrieveFail(error.response.data.message));
                    }
                }
            });
        } else {
            dispatch(retrieveSuccess({ data: { ...font } }, RETRIEVE_FONT_SUCCESS));
            if (id) {
                history.push(`/app/fonts/${id}`);
            }
        }
    };
}

export function createFont(data) {
    return function (dispatch) {
        dispatch({ type: SET_LOADING });
        axios({
            method: 'post',
            url: `${ROOT_URL}/font?lang=${env.GENERAL.lang}`,
            headers: {
                'Content-Type': 'multipart/form-data',
                Accept: env.GENERAL.accept,
                Authorization: localStorage.getItem('token')
            },
            data
        }).then((response) => {
            const fontResponse = response.data.data;
            dispatch(retrieveSuccess(fontResponse, CREATE_FONT_SUCCESS));
            history.push(`/app/fonts/${fontResponse.id}`);
        }).catch((error) => {
            handleError(error);
            if (error !== undefined) {
                if (error.response !== undefined) {
                    dispatch(retrieveFail(error.response.data.message));
                }
            }
        });
    };
}

export function updateFont(id, data) {
    return function (dispatch) {
        dispatch({ type: SET_LOADING });
        axios({
            method: 'post',
            url: `${ROOT_URL}/font/${id}?lang=${env.GENERAL.lang}`,
            headers: {
                'Content-Type': 'multipart/form-data',
                Accept: env.GENERAL.accept,
                Authorization: localStorage.getItem('token')
            },
            data
        }).then((response) => {
            const fontResponse = response.data.data;
            dispatch(retrieveSuccess(fontResponse, UPDATE_FONT_SUCCESS));
            history.push('/app/fonts');
        }).catch((error) => {
            handleError(error);
            if (error !== undefined) {
                if (error.response !== undefined) {
                    dispatch(retrieveFail(error.response.data.message));
                }
            }
        });
    };
}

export function deleteFont(id) {
    return function (dispatch) {
        dispatch({ type: SET_LOADING });
        axios({
            method: 'delete',
            url: `${ROOT_URL}/font/${id}?lang=${env.GENERAL.lang}`,
            headers: {
                'Content-Type': 'application/json',
                Accept: env.GENERAL.accept,
                Authorization: localStorage.getItem('token')
            }
        }).then((response) => {
            const fontResponse = response.data.data;
            dispatch(retrieveSuccess(fontResponse, DELETE_FONT_SUCCESS));
            history.push('/app/font');
        }).catch((error) => {
            handleError(error);
            if (error !== undefined) {
                if (error.response !== undefined) {
                    dispatch(retrieveFail(error.response.data.message));
                }
            }
        });
    };
}

function retrieveSuccess(object, action) {
    return {
        type: action,
        payload: object
    };
}

function retrieveFail(error) {
    return {
        type: SET_ERROR,
        payload: error
    };
}

